// @flow

import React from "react";
import { compose, withHandlers } from "recompose";

import { withI18n } from "@quantum/i18n";
import { ConfirmationModal, withModal } from "@quantum/ui";

type Props = {
  name: string,
  onSaveGroup: Function,
};

type EnhancedProps = {
  show: boolean,
  onConfirm: Function,
  onHide: Function,
  translate: Function,
};

const enhance = compose(
  withModal("overrideAssetGroup"),

  withI18n,

  withHandlers({
    onConfirm: ({ name, onSaveGroup }) => () =>
      onSaveGroup({ name, override: true }),
  })
);

const OverrideAssetGroupModal = ({
  name,
  show,
  onConfirm,
  onHide,
  translate,
}: Props & EnhancedProps) => (
  <ConfirmationModal
    buttonOk={translate("Comum.Sim")}
    buttonReject={translate("Comum.Nao")}
    header={() => {
      translate("Arquivo.Ja.Existe");
    }}
    message={translate("Arquivo.Salvar.Ja.Existe", [name])}
    show={show}
    onConfirm={onConfirm}
    onHide={onHide}
  />
);

export default enhance(OverrideAssetGroupModal);
